// extracted by mini-css-extract-plugin
export default {"container":"styles_container__DOpVk","resetPasswordHeader":"styles_resetPasswordHeader__06cdy","registerContainer":"styles_registerContainer__BVBk3","submit":"styles_submit__CNIkV"};